var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"outer",staticClass:"scrollText"},[_c('div',{staticClass:"st-inner",class:{'st-scrolling': _vm.needToScroll}},[_c('span',{ref:"inner",staticClass:"st-section"},[_vm._v(_vm._s(_vm.text))]),_vm._v(" "),(_vm.needToScroll)?_c('span',{staticClass:"st-section"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dad4f7b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/curriculum/watermark.vue
// module id = null
// module chunks = 